<template>
  <div class="view profile" v-if="user">

    <div class="profile-container" :page="page">

      <div class="profile-page items" v-if="page === 'applications'">
        <div class="profile-header">
          <div class="profile-title">Bewerbungen</div>
          <span class="search-field">
            <input type="search" placeholder="Suchen" v-model="searchTerms">
            <i class="fas fa-search"></i>
          </span>
        </div>
        <div class="profile-content items">
          <div class="item application" v-for="application in applications.filter(a => !searchTerms || a.project.name.toLowerCase().includes(searchTerms.toLowerCase()))" :key="application.id" :status="application.status" :cancel="selectedApplication && selectedApplication.id === application.id" :cancelled="!!application.cancelled">
            <div class="application-name">
              {{application.project.name}}
              <div class="application-status">
                <i class="fas fa-check-square" v-if="application.status === 'accepted'"></i>
                <i class="fas fa-window-close" v-if="application.status === 'rejected'"></i>
                <i class="fas fa-ellipsis-h" v-else></i>
                <span>{{translate(application.status)}}</span>
              </div>
            </div>
            <div class="application-date"><DateFormat :date="application.created_at.toDate()" format="%d/%m/%y" /></div>
            <div class="application-status">
              <i class="fas fa-check-square" v-if="application.status === 'accepted'"></i>
              <i class="fas fa-window-close" v-if="application.status === 'rejected'"></i>
              <i class="fas fa-ellipsis-h" v-else></i>
              <span>{{translate(application.status)}}</span>
            </div>
            <div class="application-cancel">
              <button class="btn warning" type="button" @click="cancelApplication(application.id)">Bewerbung zurückziehen</button>
              <button class="btn warning" type="button" @click="selectedApplication = null">Bewerbung beibehalten</button>
            </div>
            <a v-if="application.status === 'pending'" class="far fa-times-circle" @click="selectedApplication = application"></a>
          </div>
        </div>
      </div>

      <div class="profile-page items mails" :reply="replyOpened" :mini="miniReply" v-else-if="page === 'conversations'">
        <div class="profile-header">
          <div class="profile-title">Unterhaltungen</div>
          <span class="search-field">
            <input type="search" placeholder="Suchen" v-model="searchTerms">
            <i class="fas fa-search"></i>
          </span>
        </div>
        <div ref="thread" class="profile-content mails" v-if="selectedThread">
          <div class="mails-list" @click="miniReply = true">
            <div class="mail" v-for="mail in selectedThread" :key="mail.id">
              <div class="mail-sender">{{mail.from[0].name || mail.from[0].email}}</div>
              <div class="mail-date"><DateFormat :date="mail.date.toDate()" format="%Ld %d %Lm %Y at %H:%i" /></div>
              <div class="mail-content" v-html="formatMail(mail.html, searchTerms)" :is-text="mail.isHtml === false"></div>
            </div>
            <div class="reply-actions">
              <button class="btn" @click.stop="miniReply = false; replyOpened = true"><i class="fas fa-reply"></i>Antworten</button>
            </div>
          </div>
          <div class="reply-box" v-if="selectedThread" @click="miniReply = false">
            <div class="reply-container">
              <div class="reply-to">To: <span>{{selectedThread[0].sender === user.email ? selectedThread[0].to[0].name || selectedThread[0].to[0].email : selectedThread[0].from[0].name || selectedThread[0].from[0].email}}</span></div>
              <div class="reply-date"><DateFormat :date="currentDate" format="%Ld %d %Lm %Y at %H:%i" /></div>
              <div class="reply-content">
                <quill-editor class="editor" v-model="replyMessage"></quill-editor>
              </div>
              <button class="btn" @click="sendMessage"><i class="fas fa-paper-plane"></i>Senden</button>
            </div>
          </div>
        </div>
        <div class="profile-content items" v-if="!selectedThread">
          <router-link :to="`/profile/conversations/${thread[0].thread}`" class="item thread" v-for="thread in filteredThreads" :key="thread[0].thread">
            <div class="thread-name">{{thread[0].subject}}</div>
            <div class="thread-date"><DateFormat :date="thread[0].date.toDate()" format="%d/%m/%y" /></div>
          </router-link>
        </div>
        <div class="back" v-if="selectedThread">
          <router-link to="/profile/conversations">zurück zu den Unterhaltungen…</router-link>
        </div>
      </div>

      <div ref="job" class="profile-page items single" v-else-if="page === 'jobs' && selectedJob">
        <div class="job-content">
          <div class="job-header">
            <h1>{{selectedJob.name}}</h1>
            <!-- <div class="job-date"><DateFormat :date="selectedJob.created_at.toDate()" format="%d/%m/%y" /></div> -->
            <button class="btn" v-if="applications.findIndex(a => a.project.id === selectedJob.id && a.status === 'pending') === -1" @click="sendApplication" :disabled="loading">{{loading ? 'In Bearbeitung...' : 'Bewerben'}}</button>
            <button class="btn" v-else disabled>Beworben</button>
          </div>
          <div class="job-skills"><span style="text-transform: uppercase;">Fähigkeiten:</span> {{selectedJob.skills.join(', ')}}</div>
          <div class="job-description" v-html="selectedJob.description"></div>
        </div>
        <div class="buttons mobile">
          <button class="btn" v-if="user && applications.findIndex(a => a.project.id === selectedJob.id && a.status === 'pending') === -1" @click="sendApplication" :disabled="loading">{{loading ? 'In Bearbeitung...' : 'Bewerben'}}</button>
          <button class="btn" v-else-if="user" disabled>Beworben</button>
        </div>
        <div class="back">
          <router-link to="/profile/jobs">zurück zur Jobauswahl...</router-link>
        </div>
      </div>

      <div class="profile-page items" v-else-if="page === 'jobs'">
        <div class="profile-header">
          <div class="profile-title">Jobs</div>
          <div class="filters">
            <button v-if="filtersOpened" class="btn" @click="filtersOpened = false">
              <i class="fas fa-save"></i>
              <span>Filter speichern</span>
            </button>
            <button v-else class="btn" @click="filtersOpened = true">
              <i class="fas fa-filter"></i>
              <span>Filter Jobs</span>
            </button>
            <span class="search-field">
              <input type="search" placeholder="Suchen" v-model="searchTerms">
              <i class="fas fa-search"></i>
            </span>
          </div>
        </div>
        <div class="profile-content items">
          <div ref="filters" class="filters-panel" :opened="filtersOpened">
            <div class="user-skills">
              <div class="skills-title">Ausgewählte <br>Fähigkeiten</div>
              <div class="skills-list">
                <button class="btn" v-for="(skill, i) in user.skills" :key="`user-skill-${i}`" :selected="selectedSkills.includes(skill)" @click="filterSkill(skill)">{{skill}}</button>
              </div>
            </div>
            <div class="all-skills">
              <div class="skills-title">Weitere <br>Fähigkeiten hinzufügen</div>
              <div class="skills-list">
                <button class="btn" v-for="(skill, i) in skills.filter(s => !user.skills.includes(s))" :key="`skill-${i}`" :selected="selectedSkills.includes(skill)" @click="filterSkill(skill)">{{skill}}</button>
              </div>
            </div>
          </div>
          <div class="no-result" v-if="!filteredJobs.length">No jobs available yet.</div>
          <router-link :to="`/profile/jobs/${job.id}`" class="item job" v-for="job in filteredJobs" :key="job.id">
            <div class="job-name">
              {{job.name}}
              <div class="applied" v-if="applications.findIndex(a => a.project.id === job.id && a.status === 'pending') > -1">
                <i class="fas fa-clipboard-check"></i>
                <span>Beworben</span>
              </div>
            </div>
            <!-- <div class="job-date"><DateFormat :date="job.created_at.toDate()" format="%d/%m/%y" /></div> -->
            <div class="job-status">
              <div class="applied" v-if="applications.findIndex(a => a.project.id === job.id && a.status === 'pending') > -1">
                <i class="fas fa-clipboard-check"></i>
                <span>Beworben</span>
              </div>
            </div>
          </router-link>
        </div>
      </div>

      <div class="profile-page documents-page" v-else-if="page === 'documents'">
        <div class="action-buttons">
          <a class="btn" v-if="selection.length" :href="`${baseUrl}/api/files/download?token=${user.token}&files=${selection.join(',')}`"><i class="fas fa-file-download"></i><span>Download selected files</span></a>
          <button ref="uploadBtn" class="btn" @click="$refs.fileInput.click()"><i class="fas fa-file-upload"></i><span>Dokument hochladen</span></button>
          <input accept=".doc, .docx, .rtf, .txt, .xls, .xlsx, .pdf, .png, .jpg, .jpeg, .svg, .bmp, .gif, .csv, .mpg, .mp4, .mpeg, .avi, .flv, .otf" type="file" ref="fileInput" style="display: none !important;" @change="uploadFile">
        </div>
        <div class="profile-header">
          <a class="profile-title" @click="history = []; selectedFolder = user.documents">Dokumente</a>
          <a v-if="history.length" class="folders root" @click="history = []; selectedFolder = user.documents">Vorheriger Ordner</a>
          <a class="folders" v-for="(folder, i) in history" :key="folder.id" @click="history = history.slice(0, i + 1); selectedFolder = folder.id">{{folder.name}}</a>
        </div>
        <div class="profile-content documents">
          <a class="file" v-for="folder in folders.filter(f => f.parent === selectedFolder)" :key="folder.id" @click="history.push(folder); selectedFolder = folder.id">
            <i class="fas fa-folder"></i>
            <div class="file-name">{{folder.name.length > 20 ? folder.name.slice(0, 13) + '...' + folder.name.slice(-3) : folder.name}}</div>
          </a>
          <a class="file" v-for="file in files.filter(f => f.folder === selectedFolder)" :selected="selection.includes(file.id)" :key="file.id" @click="selectFile(file.id)">
            <i :class="`far fa-${getFileIcon(file.ext)}`"></i>
            <div class="file-name">{{file.name.length > 20 ? file.name.slice(0, 13) + '...' + file.name.slice(-3) : file.name}}</div>
            <button class="select-file">
              <i class="fas fa-check"></i>
            </button>
          </a>
        </div>
        <div class="buttons mobile">
          <a class="btn" v-if="selection.length" :href="`${baseUrl}/api/files/download?token=${user.token}&files=${selection.join(',')}`"><i class="fas fa-file-download"></i>Download selected files</a>
          <button ref="uploadBtn" class="btn" @click="$refs.fileInput.click()"><i class="fas fa-file-upload"></i>Dokument hochladen</button>
        </div>
      </div>

    </div>

    <div class="profile-info" :edit="editProfile">
      <h1 class="profile-name">
        <button class="profile-picture" :style="{backgroundImage: `url(${user.avatar || ''})`}" :disabled="!editProfile" @click="$refs.pictureInput.click()"><i class="far fa-image"></i></button>
        <input accept="image/*" type="file" ref="pictureInput" style="display: none !important;" @change="uploadPicture">
        <div ref="profileName">{{user.firstname}} {{user.lastname}}</div>
      </h1>
      <div class="profile-form" v-if="editProfile" :expanded="moreOptions">
        <form @submit.prevent="saveProfile">
          <div class="action-buttons">
            <button class="btn" type="submit"><i class="far fa-save"></i>Speichern</button>
          </div>
          <div class="form-part">
            <div class="fieldgroup">
              <div class="field m">
                <input placeholder="Vorname" type="text" v-model="userModel.firstname" maxlength="24" required>
              </div>
              <div class="field m">
                <input placeholder="Nachname" type="text" v-model="userModel.lastname" maxlength="24" required>
              </div>
            </div>
            <div class="fieldgroup">
              <div class="field">
                <input placeholder="E-Mail" type="email" maxlength="140" v-model="userModel.email" required>
              </div>
            </div>
            <div class="fieldgroup">
              <div class="field">
                <input placeholder="Adresse 1" type="text" maxlength="140" v-model="userModel.address1" required>
              </div>
            </div>
            <div class="fieldgroup">
              <div class="field">
                <input placeholder="Adresse 2" type="text" maxlength="140" v-model="userModel.address2">
              </div>
            </div>
            <div class="fieldgroup">
              <div class="field m">
                <input placeholder="Telefon" type="tel" maxlength="20" v-model="userModel.phone" required>
              </div>
              <div class="field m">
                <input placeholder="Mobil" type="tel" maxlength="20" v-model="userModel.mobile">
              </div>
            </div>
            <div class="fieldgroup">
              <div class="field m">
                <input placeholder="Land" type="text" maxlength="40" v-model="userModel.country" required>
              </div>
              <div class="field m">
                <input placeholder="Stadt" type="text" maxlength="40" v-model="userModel.city" required>
              </div>
            </div>
          </div>
          <div class="form-part expanded">
            <div class="fieldgroup">
              <div class="field">
                <CheckBox class="checkbox" v-model="userModel.newsletter" />
                <span>An-/Abmeldung Newsletter</span>
              </div>
            </div>
            <div class="buttons mobile">
              <button class="btn" type="submit"><i class="far fa-save"></i><span>Speichern</span></button>
            </div>
            <div class="fieldgroup">
              <div class="field">
                <a :href="`${baseUrl}/api/users/${user.id}/export?token=${user.token}`" class="btn" type="button" target="_blank"><i class="fas fa-file-export"></i>Meine Daten exportieren</a>
              </div>
            </div>
            <div class="fieldgroup">
              <div class="field delete-field" :opened="deleteOpened">
                <div class="delete-panel">
                  <i class="fas fa-exclamation"></i>
                  <p>Are you sure you want to delete your account?<br>This action is not reversible and all data will be lost.</p>
                  <div class="buttons">
                    <button class="btn warning" type="button" @click="deleteProfile">Ja, ich bin mir sicher</button>
                    <button class="btn warning" type="button" @click="deleteOpened = false">Profil behalten</button>
                  </div>
                </div>
                <button ref="deleteProfile" class="btn warning" type="button" @click="deleteOpened = true"><i class="far fa-times-circle"></i>Profil löschen</button>
              </div>
            </div>
          </div>
          <div class="more">
            <a v-if="moreOptions" @click="moreOptions = deleteOpened = false">zurück zum Profil...</a>
            <a v-else @click="moreOptions = true">weitere Optionen…</a>
          </div>
        </form>
      </div>
      <div class="profile-details" v-else>
        <div class="action-buttons">
          <button class="btn" @click="editProfile = true"><i class="far fa-edit"></i><span>Editieren</span></button>
        </div>
        <address>
          <div>{{user.address1}}</div>
          <div>{{user.address2}}</div>
          <div v-if="user.city || user.country">{{user.city}}, {{user.country}}</div>
        </address>
        <div class="info">
          <div>{{user.email}}</div>
          <div>{{user.phone}}</div>
          <div>{{user.mobile}}</div>
        </div>
        <div class="nav-buttons">
          <router-link to="/profile/documents" class="btn default" :selected="page === 'documents'">Dokumente</router-link>
          <router-link to="/profile/conversations" class="btn">Unterhaltungen</router-link>
          <router-link to="/profile/applications" class="btn">Bewerbungen</router-link>
          <router-link to="/profile/jobs" class="btn">Jobs</router-link>
        </div>
        <div class="note" v-if="page === 'jobs'">Standardmäßig werden Ihnen nur Vakanzen angezeigt, die zu Ihren eingetragenen Fähigkeiten passen. Nutzen Sie die Filter-Option am oberen Rand der Job-Auswahl um weitere Fähigkeiten hinzuzufügen.</div>
        <button class="btn sign-out" @click="auth().signOut()"><span>Abmelden</span></button>
      </div>
    </div>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import CheckBox from '../components/CheckBox.vue'
import DateFormat from '../components/DateFormat.vue'
import { setTimeout } from 'timers';

export default {
  name: 'profile',
  components: {
    CheckBox,
    DateFormat
  },
  computed: {
    ...mapGetters({
      user: 'getUser',
      auth: 'getAuth',
      storage: 'getStorage',
      db: 'getDb',
      baseUrl: 'getBaseUrl',
      functions: 'getFunctions',
      settings: 'getSettings'
    }),
    skills() {
      return this.settings.skills
    },
    page() {
      return (this.$route.params && this.$route.params.page) || 'documents'
    },
    jobId() {
      return (this.page === 'jobs' && this.$route.params && this.$route.params.id) || null
    },
    selectedJob() {
      return this.jobs.find(j => j.id === this.jobId) || null
    },
    threadId() {
      return (this.page === 'conversations' && this.$route.params && this.$route.params.id) || null
    },
    selectedThread() {
      return this.threads[this.threadId] ? this.threads[this.threadId].sort((a, b) => b.date.toDate() - a.date.toDate()) : null
    },
    filteredJobs() {
      return this.jobs.filter(j => {
        if(this.searchTerms && !j.name.toLowerCase().includes(this.searchTerms.toLowerCase())) return false
        if(!this.selectedSkills.length) return true
        return j.skills.findIndex(s => this.selectedSkills.includes(s)) > -1
      })
    },
    filteredThreads() {
      return Object.keys(this.threads).reduce((threads, key) => {
        const thread = this.threads[key]
        const index = thread.findIndex(t => t.subject.toLowerCase().includes(this.searchTerms.toLowerCase()) || t.html.toLowerCase().includes(this.searchTerms.toLowerCase()))
        if(index > -1) threads.push(thread)
        return threads
      }, [])
    }
  },
  data() {
    return {
      editProfile: false,
      moreOptions: false,
      deleteOpened: false,
      filtersOpened: false,
      replyOpened: false,
      miniReply: false,
      loading: false,
      searchTerms: '',
      userModel: null,
      selectedApplication: null,
      applications: [],
      mails: [],
      threads: {},
      jobs: [],
      selectedSkills: [],
      history: [],
      folders: [],
      files: [],
      selection: [],
      plurals: {
        company: 'companies',
        client: 'clients'
      },
      replyMessage: '',
      currentDate: new Date(),
      isMobile: (typeof window.orientation !== "undefined") || (navigator.userAgent.indexOf('IEMobile') !== -1)
    }
  },
  watch: {
    user(u, previous) {
      if(!u || !previous) this.userChanged()
      if(u) this.$nextTick(() => {this.fitText()})
    },
    deleteOpened(opened) {
      if(!opened) {
        this.$refs.deleteProfile.style.pointerEvents = 'none'
        setTimeout(() => this.$refs.deleteProfile.style.pointerEvents = null, 160)
      }
    },
    page() {
      this.replyOpened = this.miniReply = this.filtersOpened = false
      this.searchTerms = this.replyMessage = ''
      this.$store.commit('setTransition', false)
      document.querySelectorAll('.profile-content').forEach(el => el.scrollTop = 0)
    },
    threadId() {
      this.replyOpened = this.miniReply = false
      this.replyMessage = ''
    },
    selectedJob(job) {
      if(job) {
        this.$nextTick(() => {
          const pos = this.$refs.job.getBoundingClientRect()
          this.scrollToY(pos.top - 80)
        })
      }
    },
    $route() {
      this.$store.commit('setTransition', false)
    },
    filtersOpened(opened) {
      const el = this.$refs.filters
      if(!this.isMobile) return el.removeAttribute('style')
      if(!opened) return el.style.height = 0
      el.style.transition = 'none'
      el.style.height = 'auto'
      window.requestAnimFrame(() => {
        const pos = el.getBoundingClientRect()
        el.style.transition = null
        el.style.height = 0
        window.requestAnimFrame(() => {
          el.style.height = pos.height + 'px'
        })
      })
    },
    replyOpened(opened) {
      if(!this.isMobile && opened) {
        this.$nextTick(() => this.scrollToY(this.$refs.thread.scrollHeight + 400, this.$refs.thread, 1600))
      }
    }
  },
  methods: {
    fitText() {
      const el = this.$refs.profileName
      if(el && this.user) {
        if(window.innerWidth > 1024) {
          const ratio = Math.min(1, 14 / (this.user.firstname.length + this.user.lastname.length + 1))
          const size = 2.03 * ratio
          el.style.fontSize = size + 'vw'
        }
        else {
          const ratio = Math.min(1, 12 / (this.user.firstname.length + this.user.lastname.length + 1))
          const size = 34 * ratio
          el.style.fontSize = size + 'px'
        }
      }
    },
    formatMail(html, terms) {
      if(!terms) return html
      const tags = []
      html.replace(/(<([^>]+)>)/ig, (a,b,c,d) => {
        tags.push({ start: d, end: d + a.length })
        return ''
      })
      html.replace(/(&([a-zA-Z]+);)/ig, (a,b,c,d) => {
        tags.push({ start: d, end: d + a.length })
        return ''
      })
      return html.replace(new RegExp(terms, 'gi'), (exp, i) => {
        const m = tags.findIndex(t => i >= t.start && i <= t.end) === -1
        return m ? `<span style="background: #ffd675; color: #0A1612;">${exp}</span>` : exp
      })
    },
    selectFile(id) {
      const index = this.selection.findIndex(file => file === id)
      if(index > -1) this.selection.splice(index, 1)
      else this.selection.push(id)
    },
    filterSkill(skill) {
      const index = this.selectedSkills.findIndex(s => s === skill)
      if(index > -1) this.selectedSkills.splice(index, 1)
      else this.selectedSkills.push(skill)
    },
    sendMessage() {
      if(this.replyMessage) {
        this.functions.httpsCallable('sendMessage')({ thread: this.threadId, message: this.replyMessage }).then(() => {
          this.replyMessage = ''
          this.replyOpened = this.miniReply = false
        })
      }
    },
    getFileIcon(ext) {
      switch(ext) {
        case 'doc':
        case 'docx':
          return 'file-word'
        case 'pdf':
          return 'file-pdf'
        case 'ppt':
        case 'pptx':
          return 'file-powerpoint'
        case 'xls':
        case 'xlsx':
          return 'file-excel'
        case 'png':
        case 'jpg':
        case 'jpeg':
        case 'svg':
        case 'gif':
        case 'bmp':
          return 'file-image'
        case 'mpg':
        case 'mpeg':
        case 'webm':
        case 'mp4':
        case 'flv':
        case 'avi':
          return 'file-video'
        case 'zip':
        case 'rar':
        case '7z':
          return 'file-archive'
        default:
          return 'file'
      }
    },
    saveProfile() {
      this.functions.httpsCallable('updateProfile')(this.userModel)
      this.editProfile = this.moreOptions = this.deleteOpened = false
    },
    deleteProfile() {
      this.functions.httpsCallable('deleteProfile')().then(() => {
        this.auth().signOut()
      })
    },
    uploadFile(e) {
      const file = e.target.files[0]
      if(file) {
        this.$refs.uploadBtn.disabled = true
        const id = this.db().collection('files').doc().id
        const name = file.name
        const ext = name.split('.')
        const type = this.plurals[this.user.type]
        this.storage().ref(`${type}/${this.user.id}/${this.user.documents}${this.history.length ? '/' + this.history.map(h => h.id).join('/') : ''}/${id}.${ext.length > 1 ? ext.pop() : ''}`).put(file, { customMetadata: { fname: name, user_id: this.user.id } })
        .then(() => {
          this.$refs.uploadBtn.disabled = false
        })
        .catch(() => {
          this.$refs.uploadBtn.disabled = false
        })
      }
      e.target.value = ''
    },
    uploadPicture(e) {
      const file = e.target.files[0]
      if(file) {
        const name = file.name
        const ext = name.split('.')
        const type = this.plurals[this.user.type]
        this.storage().ref(`${type}/${this.user.id}/picture.${ext.length > 1 ? ext.pop() : ''}`).put(file, { customMetadata: { fname: `picture.${ext}` } })
      }
      e.target.value = ''
    },
    sendApplication() {
      this.loading = true
      this.functions.httpsCallable('submitApplication')({ project: this.selectedJob.id })
        .then(() => this.loading = false)
        .catch(() => this.loading = false)
    },
    cancelApplication(id) {
      this.selectedApplication.cancelled = true
      this.functions.httpsCallable('cancelApplication')({ application: id })
      // this.selectedApplication = null
    },
    userChanged() {
      if(this.foldersRef) this.foldersRef()
      if(this.filesRef) this.filesRef()
      if(this.applicationsRef) this.applicationsRef()
      if(this.projectsRef) this.projectsRef()
      if(this.mailsRef) this.mailsRef()
      if(this.user === undefined) return
      if(this.user === null) return this.$router.push('/login')
      this.userModel = {
        firstname: this.user.firstname,
        lastname: this.user.lastname,
        email: this.user.email,
        address1: this.user.address1,
        address2: this.user.address2,
        phone: this.user.phone,
        mobile: this.user.mobile,
        city: this.user.city,
        country: this.user.country,
        newsletter: this.user.newsletter || false
      }
      this.foldersRef = this.db().collection('folders').where('parents', 'array-contains', this.user.documents).orderBy('name').onSnapshot(folders => {
        this.folders = folders.docs.map(folder => folder.data())
      })
      this.filesRef = this.db().collection('files').where('parents', 'array-contains', this.user.documents).orderBy('name').onSnapshot(files => {
        this.files = files.docs.map(file => file.data())
      })
      this.applicationsRef = this.db().collection('applications').where('candidate.id', '==', this.user.id).orderBy('created_at', 'desc').onSnapshot(applications => {
        this.applications = applications.docs.map(application => application.data())
      })
      this.projectsRef = this.db().collection('projects').where('status', '==', 'opened').orderBy('created_at', 'desc').onSnapshot(jobs => {
        this.jobs = jobs.docs.map(job => job.data())
      })
      this.mailsRef = this.db().collection('mails').where('topic.id', '==', this.user.id).orderBy('date', 'desc').onSnapshot(mails => {
        this.mails = mails.docs.map(mail => mail.data())
        this.threads = this.mails.reduce((threads, mail) => {
          if(!threads[mail.thread]) threads[mail.thread] = []
          threads[mail.thread].push(mail)
          return threads
        }, {})
      })
      this.selectedFolder = this.user.documents
      this.selectedSkills = [].concat(this.user.skills || [])
    }
  },
  mounted: function() {
    this.$store.commit('setTransition', false)
    this.userChanged()
    this.dateInterval = setInterval(() => this.currentDate = new Date(), 500)
    window.addEventListener('resize', this.fitText.bind(this))
    this.fitText()
  },
  beforeDestroy: function() {
    window.removeEventListener('resize', this.fitText.bind(this))
    clearInterval(this.dateInterval)
    if(this.foldersRef) this.foldersRef()
    if(this.filesRef) this.filesRef()
    if(this.applicationsRef) this.applicationsRef()
    if(this.projectsRef) this.projectsRef()
    if(this.mailsRef) this.mailsRef()
  }
}
</script>

<style scoped>
.profile {
  display: flex;
  justify-content: space-between;
  width: 72.08vw;
  margin: auto;
  padding-top: 19.72vh;
}

.profile .btn span {
  padding-top: .2em;
}

.profile-form {
  margin-top: 3.2vh;
}

.profile-form .delete-field {
  position: relative;
}

.profile-form .delete-panel {
  position: relative;
  border: 1px solid rgba(255, 102, 102, 0.23);
  text-align: center;
  padding: 1.94vh 0;
  pointer-events: none;
  opacity: 0;
  z-index: 1;
}

.profile-form .delete-field > .btn {
  position: absolute;
  top: 0;
  transition: width .16s ease-out, height .16s ease-out;
}

.profile-form .delete-field[opened] > .btn {
  transition: width .16s ease-out, height .16s ease-out, .16s opacity .16s ease-in;
  width: 100%;
  height: 100%;
  opacity: 0;
  background: none;
  color: transparent;
}

.profile-form .delete-field[opened] .delete-panel {
  transition: .16s opacity .16s ease-out;
  opacity: 1;
  pointer-events: all;
}

.profile-form .delete-panel i {
  display: block;
  color: #ff6666;
}

.profile-form .delete-panel p {
  font-size: 1.39vh;
  margin: 1.48vh 0;
}

.profile-form .form-part.expanded,
.profile-form[expanded] .form-part {
  display: none;
}

.profile-form[expanded] .form-part.expanded {
  display: block;
}

.profile-form .form-part .delete-panel .btn {
  width: 9.11vw;
  margin: 0 .625vw;
  padding: 0;
}

.profile-form .fieldgroup {
  margin: 0 -.625vw 2.68vh;
}

.profile-form .field {
  padding: 0 .625vw;
}

.profile-form .checkbox {
  margin-right: 16px;
}

.profile-form input {
  height: 6.38vh;
  background: none;
  border: 1px solid rgba(255,255,255,.23);
  border-radius: 0;
  padding: 0 1.25vw;
  font-size: 1.39vh;
}

.profile-form .form-part {
  height: 51.57vh;
}

.profile-form .form-part .btn {
  width: 12.68vw;
  font-size: .73vw;
}

.profile-form .form-part .btn i {
  margin: -1px 8px 0 0;
}

.profile-form .more {
  text-align: right;
  margin-top: 2vh;
}

.profile-form .more a {
  text-decoration: underline;
  font-size: 1.39vh;
}

.profile-container:not([page="documents"]) {
  padding-top: 5.56vh;
}

.profile-container .back {
  text-align: right;
}

.profile-container .back a {
  text-decoration: underline;
}

.job-content {
  position: relative;
  display: flex;
  flex-flow: column nowrap;
  height: 58vh;
  padding: 1.85vh 2.18vw;
  background: rgba(82, 82, 102, 0.46);
  margin-bottom: 1.11vh;
}

.job-content:before,
.job-content:after {
  content: '';
  position: absolute;
  left: 0;
  bottom: 0;
  right: calc(2.18vw + 8px);
  height: calc(1.85vh + 42px);
  background: rgb(41,41,51);
  background: -moz-linear-gradient(0deg, rgba(41,41,51,1) 0%, rgba(41,41,51,1) 30%, rgba(43,49,56,0.46) 100%);
  background: -webkit-linear-gradient(0deg, rgba(41,41,51,1) 0%, rgba(41,41,51,1) 30%, rgba(43,49,56,0.46) 100%);
  background: linear-gradient(0deg, rgba(41,41,51,1) 0%, rgba(41,41,51,1) 30%, rgba(43,49,56,0.46) 100%);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#292933",endColorstr="#2b3138",GradientType=1);
}

.job-content:before {
  z-index: 2;
}

.job-content:after {
  left: auto;
  right: 0;
  width: calc(2.18vw + 8px);
}

.job-content .job-header {
  display: flex;
  align-items: center;
  margin-bottom: 1.85vh;
  flex-shrink: 0;
}

.job-content .job-header h1 {
  font-size: 1.11vh;
  font-weight: 500;
  color:#ffd675;
  letter-spacing: .2em;
  flex-grow: 1;
  position: relative;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.job-content .job-header .btn {
  background:#ffd675;
  color:#0A1612;
  text-transform: uppercase;
  width: 7.4vw;
  margin-left: 2.19vw;
  font-weight: 500;
}

.job-content .job-header .job-date {
  font-size: .93vh;
  letter-spacing: .4em;
}

.job-content .job-skills {
  font-size: .93vh;
  letter-spacing: .4em;
}

.job-content .job-description {
  position: relative;
  overflow: auto;
  letter-spacing: .05em;
  margin-top: 1.85vh;
  flex-grow: 1;
  padding-right: 16px;
  padding-bottom: 42px;
  line-height: 1.875;
  z-index: 1;
}

.job-content .job-description >>> * {
  background: none !important;
  color: #fff !important;
}

.job-content .job-description >>> p {
  margin: 0 0 0;
}

.profile-container {
  width: 38.75vw;
  padding-top: 2.04vh;
  transition: opacity .16s ease-out;
  will-change: opacity;
}

.profile-container[page] {
  opacity: 1;
}

[page-loading] .profile-container {
  opacity: 0;
}

.profile-container .action-buttons {
  display: flex;
  justify-content: flex-end;
  padding-right: 14px;
}

.profile-container .action-buttons .btn {
  margin-left: .73vw;
}

.profile-container .profile-header {
  display: flex;
  align-items: center;
  margin-bottom: 1.11vh;
  padding-right: 14px;
}

.profile-page.items .profile-header {
  justify-content: space-between;
}

.profile-page.items .profile-header .btn {
  width: 8.96vw;
  font-size: .73vw;
}

.profile-page.items .profile-header .btn span {
  display: block;
  /* margin-top: 3px; */
}

.profile-page.mails {
  position: relative;
}

.profile-page.mails .back {
  margin-top: 1.3vh;
  padding-right: 14px;
}

.profile-container .search-field {
  position: relative;
  display: inline-block;
  vertical-align: middle;
  margin-left: .83vw;
}

.profile-container .search-field i {
  position: absolute;
  right: 1.04vw;
  top: 1.25vh;
  font-size: 1.3vh;
  opacity: .5;
  pointer-events: none;
}

.profile-container .search-field input {
  width: 11.46vw;
  padding: 0 .94vw;
  background: rgba(82, 82, 102, 0.23);
  border-radius: 0;
}

.profile-container .profile-header .profile-title {
  color: #525266;
  border: 1px solid;
  text-transform: uppercase;
  padding: 1.04vh .83vw .74vh;
  letter-spacing: .4em;
}

.profile-container .profile-header .folders {
  letter-spacing: .4em;
}

.profile-container .profile-header .folders:before {
  content: '/';
  color:#525266;
  margin: 0 .1vw 0 .63vw;
}

.profile-content {
  position: relative;
  display: flex;
  flex-flow: row wrap;
  align-items: flex-start;
  align-content: flex-start;
  justify-content: flex-start;
  overflow: auto;
  overflow-y: scroll;
  overflow-x: hidden;
  padding-right: 8px;
}

.profile-content.documents {
  height: 51.57vh;
}

.profile-content.mails {
  display: block;
  height: 51.57vh;
}

.profile-content .no-result {
  position: absolute;
  top: 47%;
  left: 0;
  right: 0;
  text-align: center;
}

.profile-content.mails .mails-list {
  width: 100%;
  /* min-height: 100%; */
  background: rgba(82, 82, 102, 0.23);
}

.profile-page .editor {
  letter-spacing: .05em;
}

.profile-page .editor >>> .ql-container.ql-snow,
.profile-page .editor >>> .ql-toolbar.ql-snow {
  border: none;
}

.profile-page .editor >>> .ql-editor {
  height: 18.52vh;
  padding: 0;
}

.profile-page .editor >>> .ql-editor.ql-blank::before {
  color: rgba(255,255,255,.5);
  font-style: normal;
  left: 0;
}

.profile-page .editor >>> .ql-toolbar.ql-snow {
  position: absolute;
  top: 29.2vh;
  left: 10vw;
}

.profile-content.mails .mails-list > .mail {
  background: #333a43;
  padding: 2.22vh 2.19vw;
}

.profile-content.mails .mails-list .mail .mail-sender,
.profile-page .reply-to span {
  color:#ffd675;
  text-transform: uppercase;
  font-weight: 500;
  letter-spacing: .4em;
  margin-bottom: .37vh;
  font-size: 1.11vh;
}

.profile-page .reply-to,
.profile-page .reply-date,
.profile-content.mails .mails-list .mail .mail-date {
  font-size: .93vh;
  letter-spacing: .4em;
  border-bottom: 1px solid #525266;
  padding-bottom: .37vh;
  margin-bottom: 1.85vh;
}

.profile-page .reply-to {
  margin-bottom: .37vh;
  padding: 0;
  border: none;
}

.profile-content.mails .mails-list .mail .mail-content {
  line-height: 1.875;
  letter-spacing: .05em;
}

.profile-content.mails .mails-list .reply-actions {
  text-align: center;
  margin-top: -1.76vh;
  padding-bottom: 4.63vh;
}

.profile-content.mails .mails-list .reply-actions .btn,
.profile-page .reply-box .reply-container > .btn {
  background:#0A1612;
  color:#ffd675;
  width: 7.4vw;
}

.profile-page .reply-box .reply-container > .btn {
  background:#ffd675;
  color:#0A1612;
}

.profile-page .reply-box {
  /* position: absolute;
  left: 0;
  right: 14px;
  bottom: 3.2vh; */
  position: relative;
  background: #202b2d;
  overflow: hidden;
  height: 0;
  transition: height .32s ease-out;
  opacity: 0;
  pointer-events: none;
}

.profile-page .reply-box .reply-container {
  padding: 2.22vh 2.19vw;
}

.profile-page[reply] .profile-content.mails .mails-list {
  /* padding-bottom: 36.11vh;
  cursor: pointer; */
}

/* .profile-page[reply][mini] .profile-content.mails .mails-list {
  padding-bottom: 10vh;
  cursor: default;
} */

.profile-page[reply] .mails-list .reply-actions {
  display: none;
}

.profile-page[reply] .reply-box {
  height: 36.11vh;
  opacity: 1;
  pointer-events: all;
}

/* .profile-page[reply][mini] .reply-box {
  height: 10vh;
  cursor: pointer;
} */

.profile-page .reply-box .editor {
  margin-bottom: 3.88vh;
}

.profile-content.items {
  height: 51.57vh;
  flex-flow: column nowrap;
}

.profile-content .filters-panel {
  position: absolute;
  top: 5%;
  left: 0;
  right: 8px;
  bottom: 0;
  z-index: 2;
  transition: .16s transform .16s ease-out, .16s opacity .16s ease-out, top .16s ease-out;
  opacity: 0;
  transform: translateY(-100%);
  pointer-events: none;
  height: 100%;
  overflow: hidden;
}

.profile-content .filters-panel[opened] {
  transform: none;
  opacity: 1;
  pointer-events: all;
  height: auto;
  overflow: unset;
  top: 0;
  transition: transform .16s ease-out, opacity .16s ease-out, .16s top .16s ease-out;
}

.profile-content .filters-panel .user-skills {
  background: #202b2d;
  border-bottom: 3px solid #0A1612;
}

.profile-content .filters-panel .all-skills {
  background: #333a43;
}

.profile-content .filters-panel .user-skills,
.profile-content .filters-panel .all-skills {
  display: flex;
  padding: 3.52vh 1.875vw 2.13vh;
}

.profile-content .filters-panel .skills-title {
  width: 4.8vw;
  opacity: .5;
  flex-shrink: 0;
}

.profile-content .filters-panel .skills-list {
  display: flex;
  width: 100%;
  flex-flow: row wrap;
  /* justify-content: space-between; */
}

.profile-content .filters-panel .btn {
  width: 8.8vw;
  margin-bottom: 1.39vh;
  margin-left: .83vw;
  background: #0A1612;
  color: #ffd675;
}

.profile-content .filters-panel .btn[selected] {
  background: #ffd675;
  color: #0A1612;
}

.profile-content .item {
  position: relative;
  display: flex;
  justify-content: space-between;
  width: 100%;
  height: 7.22vh;
  align-items: center;
  background: rgba(82, 82, 102, 0.23);
  padding: 0 2.19vw;
  font-size: .93vh;
  letter-spacing: .4em;
  color: #fff;
  flex-shrink: 0;
}

.profile-content .application {
  background: none !important;
  overflow: hidden;
  transition: height .32s ease-in;
}

.profile-content .application[cancelled] {
  height: 0;
}

.profile-content .application:before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  bottom: 0;
  transition: all .32s ease-out;
  background: rgba(82, 82, 102, 0.23);
}

.profile-content .item:nth-child(odd),
.profile-content .application:nth-child(odd):before {
  background: rgba(82, 82, 102, 0.46);
}

.profile-content .application[cancel]:before {
  opacity: 1;
  background: rgba(255, 102, 102, 0.46);
  width: .52vw;
}

.profile-content .application[cancel] {
  background: #0A1612;
}

.profile-content .item > *:not(a) {
  position: relative;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.profile-content .thread .thread-name,
.profile-content .application .application-name,
.profile-content .job .job-name {
  color: #ffd675;
  width: 17.19vw;
  font-weight: 500;
  font-size: 1.11vh;
  letter-spacing: .2em;
}

.profile-content .application[cancel] .application-name {
  width: auto;
  flex-grow: 1;
  padding-right: 8px;
}

.profile-content .item > a {
  position: absolute;
  display: block;
  right: .83vw;
  top: 2.96vh;
  font-size: 1.3vh;
  opacity: .5;
  color:#ff6666;
}

.profile-content .application .application-cancel,
.profile-content .job .job-name .applied,
.profile-content .application .application-name .status,
.profile-form .buttons.mobile,
.profile-page.documents-page .buttons.mobile,
.profile-page.items .buttons.mobile,
.profile-container .profile-header .folders.root,
.profile-content .application .application-name .application-status,
.profile-content .application[cancel] .application-date,
.profile-content .application[cancel] .application-status,
.profile-content .application[cancel] > a {
  display: none;
}

.profile-content .application .application-cancel .btn:last-child {
  margin-left: 1.04vw;
}

.profile-content .application .application-status {
  display: flex;
  align-items: center;
  text-transform: capitalize;
}

.profile-content .application .application-status span {
  display: block;
  min-width: 3.9vw;
  margin-left: .52vw;
}

.profile-content .application .application-status i {
  color: #ffd675;
  font-size: 1.3vh;
}

.profile-content .application[status="accepted"] .application-status i {
  color: #1ABC9C;
}

.profile-content .application[status="rejected"] .application-status i {
  color: #ff6666;
}

.profile-content .application[cancel] .application-cancel {
  display: block;
  flex-shrink: 0;
}

.profile-content .job .job-status {
  width: 5.47vw;
}

.profile-content .job .applied i {
  color:#1ABC9C;
  font-size: 1.3vh;
  margin-right: .52vw;
}

.profile-content .file {
  position: relative;
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
  text-align: center;
  width: 25%;
  height: 9.64vw;
  background: rgba(82, 82, 102, 0.23);
  color: #fff;
  padding: 0 .58vw;
  border: 1px solid #0A1612;
  /* margin: -1px; */
}

.profile-content .file .select-file {
  position: absolute;
  width: 1.66vh;
  height: 1.66vh;
  top: 1.11vh;
  right: 1.11vh;
  border: 1px solid #525266;
  background: #0A1612;
  border-radius: 50%;
  opacity: 0;
  transition: all .16s ease-out;
}

.profile-content .file .select-file i {
  display: block;
  font-size: .88vh;
  opacity: 0;
  transition: opacity .16s ease-out;
}

.profile-content .file[selected] .select-file,
.profile-content .file[selected] .select-file i {
  opacity: 1;
  color: #0A1612;
}

@media screen and (min-width: 1025px) {
  .profile-content .file:hover .select-file {
    opacity: 1;
    color: #0A1612;
  }
}

.profile-content .file[selected] .select-file {
  background: #ffd675;
  border-color: #ffd675;
}

.profile-content .file i {
  font-size: 2.96vh;
  color: #ffd675;
}

.profile-content .file .file-name {
  margin-top: 1.11vh;
  font-size: .73vw;
  letter-spacing: .3em;
  line-height: 1.85vh;
  word-break: break-word;
  height: 3.52vh;
}

.profile-info {
  position: relative;
  width: 26.82vw;
}

.profile-info .profile-picture {
  position: absolute;
  right: 100%;
  top: 50%;
  transform: translateY(-50%);
  width: 3.33vw;
  height: 3.33vw;
  border-radius: 50%;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  background-image: url(../assets/tr_ic_user.svg);
  margin-right: .83vw;
  overflow: hidden;
  font-size: 16px;
  opacity: 1;
}

.profile-info .profile-picture i {
  position: relative;
  opacity: 0;
  z-index: 1;
}

.profile-info[edit] .profile-picture i {
  opacity: 1;
}

.profile-info[edit] .profile-picture:after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color:rgba(82, 82, 102, 0.64);
}

.profile-info .note {
  opacity: .5;
  font-style: italic;
  font-size: .78vw;
  margin-top: 3.33vh;
  line-height: 1.33;
}

.profile-info .action-buttons {
  position: absolute;
  top: .78vw;
  right: 0;
}

.profile-info .action-buttons .btn {
  width: 7.29vw;
}

.profile-info .btn.sign-out {
  position: absolute;
  right: 0;
  bottom: 0;
}

.profile-info h1 {
  position: relative;
  font: 400 3.61vh/1 'Exodus Demo';
  height: 3.125vw;
  color: #ffd675;
  margin: 0 8vw 1.11vh 0;
  white-space: nowrap;
}

.profile-info h1 div {
  position: relative;
  /* overflow: hidden;
  text-overflow: ellipsis; */
  display: inline-block;
  border-bottom: 1px solid;
  padding: 1.11vh 0;
  max-width: 100%;
}

.profile-info address {
  font-size: 1.11vh;
  font-weight: 500;
  font-style: normal;
  letter-spacing: .4em;
  line-height: 1.85vh;
  white-space: nowrap;
}

.profile-info address > * {
  position: relative;
  overflow: hidden;
  text-overflow: ellipsis;
}

.profile-info .info {
  margin-top: 1.11vh;
  font-size: 1.3vh;
  letter-spacing: .4em;
  line-height: 1.5;
}

.nav-buttons {
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  margin-top: 1.85vh;
}

.nav-buttons a {
  width: 13.02vw;
  height: 8.05vh;
  margin-bottom: 1.3vh;
  font-size: .68vw;
  text-transform: uppercase;
  letter-spacing: .3em;
  padding-top: .2em;
}

.nav-buttons .router-link-active:not(.default),
.nav-buttons a.default[selected] {
  background: #ffd675;
  color: #0A1612;
}

.btn i {
  margin-right: 8px;
}

@media screen and (max-width: 1024px) {
  .profile {
    width: auto;
    padding: 0 20px;
    flex-flow: column-reverse nowrap;
  }
  .profile-container,
  .profile-info {
    width: auto;
  }
  .profile-info h1 {
    display: flex;
    align-items: center;
    height: 32px;
  }
  .profile-info h1 div {
    font-size: 34px;
    padding: 0;
    border: none;
  }
  .profile-info .action-buttons {
    top: 0;
  }
  .profile-info .action-buttons .btn {
    width: 32px;
    height: 32px;
    padding: 0;
    font-size: 0;
  }
  .profile-info .action-buttons .btn i {
    font-size: 14px;
    margin: 0;
  }
  .profile-info h1,
  .profile-info address,
  .profile-info .info {
    margin-left: 60px;
  }
  .profile-info .profile-picture {
    width: 48px;
    height: 48px;
    right: auto;
    left: -60px;
  }
  .profile-info address {
    font-size: 12px;
    line-height: 20px;
    text-transform: uppercase;
  }
  .profile-info .info {
    margin-top: 12px;
    font-size: 12px;
    font-weight: 300;
  }
  .profile-form .form-part.expanded,
  .profile-form .buttons.mobile,
  .profile-page.documents-page .buttons.mobile,
  .profile-form[expanded] .form-part {
    display: block;
  }
  .profile-form .form-part.expanded {
    text-align: center;
  }
  .profile-form .form-part.expanded .field {
    margin: 0;
  }
  .profile-form .form-part.expanded .fieldgroup:first-child {
    text-align: left;
  }
  .profile-form .form-part.expanded .fieldgroup:last-child {
    margin-top: 72px;
  }
  .profile-form .buttons.mobile {
    margin: 22px 0 42px;
  }
  .profile-form .delete-panel {
    padding: 16px 0 30px;
  }
  .profile-form .delete-panel p {
    font-size: 12px;
    margin: 12px 0 30px;
  }
  .profile-form .delete-field {
    height: 38px;
    transition: .16s height .16s;
  }
  .profile-form .delete-field[opened] {
    transition: none;
    height: 300px;
  }
  .profile-form .form-part .delete-panel .btn {
    display: flex;
    width: 175px;
    height: 64px;
    margin: auto;
    padding: 0;
  }
  .profile-form .form-part .delete-panel .btn:first-child {
    margin-bottom: 30px;
  }
  .profile-form .form-part .btn {
    width: 265px;
    height: 38px;
    font-size: 14px;
  }
  .profile-form .delete-field > .btn {
    left: 0;
    right: 0;
    margin: auto;
  }
  .profile-form .delete-field[opened] > .btn {
    width: 100%;
  }
  .profile-form .buttons.mobile .btn {
    display: flex;
    width: 100%;
    height: 72px;
    font-size: 12px;
    font-weight: 900;
    text-transform: uppercase;
    letter-spacing: .3em;
  }
  .profile-form .buttons.mobile .btn i {
    font-size: 14px;
  }
  .nav-buttons {
    margin-top: 24px;
  }
  .nav-buttons a {
    width: 50%;
    margin: 0;
    flex-shrink: 0;
    height: 64px;
    font-size: 12px;
  }
  .profile-info .btn.sign-out {
    position: relative;
    display: flex;
    margin: 24px 0 0 auto;
  }
  .profile-form {
    margin-top: 42px;
  }
  .profile-form input {
    height: 42px;
    font-size: 13px;
    padding: 0 16px;
    border-color: rgba(82, 82, 102, 0.77);
  }
  .profile-form .form-part {
    height: auto;
  }
  .profile-form .fieldgroup {
    margin: 0;
    flex-flow: column nowrap;
  }
  .profile-form .field {
    padding: 0;
    width: 100%;
    margin: 0 0 20px;
  }
  .profile-container .profile-header .profile-title,
  .profile-content .job .job-status,
  .job-content .job-header .btn,
  .profile-container .back,
  .job-content:before,
  .job-content:after,
  .profile-form .more,
  .profile-info[edit] .action-buttons .btn,
  .profile-content .application .application-status,
  .profile-content .filters-panel .skills-title br,
  .profile-container .documents-page .action-buttons {
    display: none;
  }
  .profile-container .action-buttons {
    padding: 0;
  }
  .profile-content.documents {
    height: auto;
    padding: 0;
  }
  .profile-content .file {
    width: 50%;
    height: 44.69vw;
  }
  .profile-content .file i {
    font-size: 32px;
  }
  .profile-content .file .file-name {
    font-size: 14px;
  }
  .profile-page.items .buttons.mobile {
    display: block;
  }
  .profile-content .item.application {
    padding-right: 78px;
  }
  .profile-content .item > a {
    font-size: 14px;
    top: 32px;
    right: 40px;
  }
  .profile-content .application[cancel] .application-cancel {
    position: absolute;
    top: 78px;
    flex-shrink: 1;
  }
  .profile-content .application[cancel] {
    height: 158px;
    align-items: flex-start;
    padding-top: 20px;
  }
  .profile-content .application[cancel]:before {
    width: 15px;
  }
  .profile-content .application .application-cancel .btn {
    padding: 0 16px;
    height: 38px;
  }
  .profile-content .application .application-cancel .btn:last-child {
    margin-left: 16px;
  }
  .profile-container[page="applications"] .search-field,
  .profile-container[page="conversations"] .search-field {
    width: 100%;
  }
  .profile-content .application .application-name .application-status {
    display: flex;
    margin-top: 8px;
  }
  .profile-content .application .application-status span {
    color: #fff;
    font-size: 10px;
    letter-spacing: .4em;
    margin-left: 8px;
  }
  .profile-content .application .application-status i {
    font-size: 14px;
  }
  .documents-page .buttons.mobile .btn {
    display: flex;
    width: 100%;
    height: 72px;
    margin-top: 20px;
    font-size: 12px;
    font-weight: 900;
    text-transform: uppercase;
    letter-spacing: .3em;
  }
  .profile-container .profile-header .folders.root {
    display: inline;
    color: #525266;
  }
  .profile-content.items {
    margin: 0 -30px;
  }
  .profile-page.items .profile-header,
  .profile-content.items {
    padding: 0;
    height: auto;
  }
  .profile-page.items .profile-header {
    display: block;
    margin-bottom: 20px;
  }
  .profile-page.items .profile-header .filters {
    display: flex;
    justify-content: space-between;
  }
  .profile-container .search-field,
  .profile-page.items .profile-header .btn {
    width: 47%;
    height: 38px;
    margin: 0;
    padding: 0;
    font-size: 12px;
  }
  .profile-container .search-field input {
    width: 100%;
    height: 100%;
    padding: 0 16px;
  }
  .profile-container .search-field i {
    top: 12px;
    right: 16px;
    font-size: 14px;
  }
  .profile-content .job .job-name .applied {
    display: block;
    color: #fff;
    font-size: 10px;
    margin-top: 4px;
  }
  .profile-content .item {
    height: 78px;
    padding: 0 30px;
    font-size: 10px;
  }
  .profile-content.mails {
    padding: 0;
    height: auto;
  }
  .profile-content.mails .mails-list > .mail {
    padding: 24px 20px;
  }
  .profile-content.mails .mails-list .mail .mail-sender,
  .profile-page .reply-to span {
    font-size: 12px;
    margin-bottom: 4px;
  }
  .profile-page .reply-to,
  .profile-page .reply-date,
  .profile-content.mails .mails-list .mail .mail-date {
    font-size: 10px;
  }
  .profile-page .reply-box {
    /* bottom: 0;
    right: 0; */
  }
  .profile-page .reply-box .reply-container {
    padding: 18px 20px;
  }
  .profile-page[reply] .reply-box/*,
  .profile-page[reply][mini] .reply-box*/ {
    height: 462px;
  }
  /* .profile-page[reply] .profile-content.mails .mails-list,
  .profile-page[reply][mini] .profile-content.mails .mails-list {
    padding-bottom: 462px;
  } */
  .profile-page .editor >>> .ql-toolbar.ql-snow {
    top: auto;
    bottom: 100px;
    left: 20px;
    right: 20px;
    padding: 8px 0;
  }
  .profile-page .editor >>> .ql-editor {
    height: 230px;
  }
  .profile-page .reply-box .editor {
    margin-bottom: 72px;
  }
  .profile-content.mails .mails-list .reply-actions {
    margin-top: -19px;
    padding-bottom: 50px;
  }
  .profile-content.mails .mails-list .reply-actions .btn {
    width: 142px;
    padding: 0;
    height: 38px;
    font-size: 14px;
  }
  .profile-page .reply-box .reply-container > .btn {
    display: flex;
    width: 100%;
    height: 72px;
    font-weight: 900;
    text-transform: uppercase;
    letter-spacing: .3em;
    font-size: 12px;
  }
  .profile-page .reply-box .reply-container > .btn i {
    font-size: 14px;
  }
  .profile-content .application .application-name,
  .profile-content .thread .thread-name,
  .profile-content .job .job-name {
    font-size: 12px;
    flex-grow: 1;
  }
  .profile-content .filters-panel {
    position: relative;
    transform: none;
    right: 0;
    overflow: hidden;
    transition: height .16s ease-out, opacity .16s ease-out;
    height: 0;
    margin: 0 30px;
  }
  .profile-content .filters-panel[opened] {
    margin-bottom: 20px;
  }
  .profile-content .filters-panel .skills-list {
    justify-content: space-between;
  }
  .profile-content .filters-panel .user-skills,
  .profile-content .filters-panel .all-skills {
    display: block;
    padding: 20px;
  }
  .profile-content .filters-panel .btn {
    margin: 16px 0 0 0;
    width: 47%;
    font-size: 13px;
    height: 47px;
  }
  .profile-content .filters-panel .skills-title {
    width: auto;
  }
  .job-content {
    padding: 30px;
    height: auto;
    margin: 0 0 32px;
  }
  .job-content .job-header {
    margin-bottom: 18px;
  }
  .job-content .job-header h1 {
    font-size: 12px;
    margin: 0;
  }
  .job-content .job-header .job-date {
    font-size: 10px;
  }
  .job-content .job-skills {
    font-size: 11px;
  }
  .job-content .job-description {
    padding: 0;
    margin-top: 32px;
    font-size: 16px;
  }
  .profile-page.single .buttons .btn {
    display: block;
    width: calc(100% - 84px);
    height: 72px;
    background:#ffd675;
    color:#0A1612;
    text-transform: uppercase;
    font-weight: 900;
    font-size: 12px;
    letter-spacing: .3em;
    margin: auto
  }
  .profile-info .note {
    font-size: 14px;
    margin-top: 26px;
  }
}
</style>
